import React from 'react'

import { UppercaseButton } from 'Common/styled'

const Button = props => {
  const { children, ...otherProps } = props
  return (
    <UppercaseButton type={'primary'} size={'large'} {...otherProps}>
      <span>{children}</span>
    </UppercaseButton>
  )
}
export default Button
